import React from 'react';
import { Table, ScrollArea, useMantineTheme, Group, Text } from '@mantine/core';
import { IconPencil, IconTrash, IconFilePencil } from '@tabler/icons-react';

import { arrayObjectToStringWithDivider } from "../../utils/globalFunctions";

import THSort from "../../components/general/THSort";
import THPlain from "../../components/general/THPlain";
import ActionIconComponent from "../../components/general/ActionIconComponent";

const BarangFormCekTable = ({
    stateData,
    stateSortList,
    stateSortSelected,
    fnSort,
    stateDataOffset,

    fnSelectedDataEditMaster,
    fnSelectedDataEditDetil,
    fnSelectedDataDelete,
    fnSelectedDataView
}) => {

    const theme = useMantineTheme();

    const TD = ({ children, stateNoWrap = true }) => {
        return (
            <td
                style={{
                    whiteSpace: stateNoWrap ? 'nowrap' : 'normal',
                    color: theme.colorScheme === 'light' ? theme.colors.gray[7] : theme.colors.gray[6],
                }}
            >
                {children}
            </td>
        )
    }

    return (
        <ScrollArea>
            <Table
                highlightOnHover
                verticalSpacing="sm"

                sx={() => ({
                    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[8],

                    '& thead.tableHeadSticky': {
                        position: 'sticky',
                        top: '0px',
                    },

                    '& thead tr th': {
                        paddingTop: theme.spacing.sm,
                        paddingBottom: theme.spacing.sm,
                    },
                    '& thead tr th.THSort:hover': {
                        backgroundColor: `${theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[5]} !important`
                    },
                    '& thead tr th:not(:nth-last-of-type(1)) .wrapperContentTH': {
                        borderRight: `1px solid ${theme.colorScheme === 'light' ? theme.colors.gray[4] : theme.colors.dark[4]}`,
                    },
                })}
            >
                <thead>
                    <tr>
                        <THPlain stateCaption='No' />

                        <THSort
                            stateSortInUse={stateSortList.barangFormCekName}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THPlain stateCaption='List Item' />

                        <THSort
                            stateSortInUse={stateSortList.barangFormCekIsActive}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THPlain stateCaption='' />
                    </tr>
                </thead>

                <tbody>
                    {Object.keys(stateData).map((key, index) => {
                        return (
                            <tr
                                key={key}
                                style={{
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    fnSelectedDataView(stateData[key]);
                                }}
                            >
                                <TD>{Number(stateDataOffset) + Number(index) + 1}</TD>

                                <TD>{stateData[key].barang_form_cek_name}</TD>

                                <TD>
                                    <Text
                                        lineClamp={1}
                                    >
                                        ({Array.isArray(stateData[key].barang_form_cek_detil) ? stateData[key].barang_form_cek_detil.length : 0}) {arrayObjectToStringWithDivider(stateData[key].barang_form_cek_detil, 'barang_form_cek_detil_name', ', ', '-')}
                                    </Text>
                                </TD>


                                <TD>{stateData[key].barang_form_cek_is_active === '1' ? 'Aktif' : 'Non Aktif'}</TD>

                                <TD>
                                    <Group spacing='xs' noWrap>
                                        <ActionIconComponent
                                            stateVariant='subtle'
                                            stateRadius='xl'
                                            stateTitle='Edit Nama Form'
                                            stateSize='lg'

                                            StateIcon={IconPencil}
                                            stateIconSize='1.1rem'
                                            stateIconStrokeWidth={1}

                                            stateSXActionIcon={{
                                                '&:hover': {
                                                    backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[4]
                                                },
                                            }}

                                            stateIconStyle={{
                                                color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                            }}

                                            fnOnClick={(e) => {
                                                e.stopPropagation();
                                                fnSelectedDataEditMaster(stateData[key]);
                                            }}
                                        />

                                        <ActionIconComponent
                                            stateVariant='subtle'
                                            stateRadius='xl'
                                            stateTitle='Edit Detil Form'
                                            stateSize='lg'

                                            StateIcon={IconFilePencil}
                                            stateIconSize='1.1rem'
                                            stateIconStrokeWidth={1}

                                            stateSXActionIcon={{
                                                '&:hover': {
                                                    backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[4]
                                                },
                                            }}

                                            stateIconStyle={{
                                                color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                            }}

                                            fnOnClick={(e) => {
                                                e.stopPropagation();
                                                fnSelectedDataEditDetil(stateData[key]);
                                            }}
                                        />

                                        <ActionIconComponent
                                            stateVariant='subtle'
                                            stateRadius='xl'
                                            stateTitle='Delete'
                                            stateSize='lg'

                                            StateIcon={IconTrash}
                                            stateIconSize='1.1rem'
                                            stateIconStrokeWidth={1}

                                            stateSXActionIcon={{
                                                '&:hover': {
                                                    backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[4]
                                                },
                                            }}

                                            stateIconStyle={{
                                                color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                            }}

                                            fnOnClick={(e) => {
                                                e.stopPropagation();
                                                fnSelectedDataDelete(stateData[key]);
                                            }}
                                        />
                                    </Group>
                                </TD>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </ScrollArea>
    )
}

export default React.memo(BarangFormCekTable);